// Mobile menu accordion functionality
document.addEventListener("DOMContentLoaded", () => {
  // Track if menu is open to manage body scroll
  let isMenuOpen = false;

  // Function to disable body scrolling but allow menu scrolling
  function disableBodyScroll() {
    // Save current scroll position before locking
    window.menuScrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;
    // Add class to prevent body scrolling
    document.body.classList.add("menu-open");

    // Fix the menu's position and scrolling
    const menuDrawer = document.getElementById("menu-drawer");
    if (menuDrawer) {
      // Ensure menu is scrollable
      menuDrawer.style.overflowY = "auto";
      menuDrawer.style.webkitOverflowScrolling = "touch"; // For better iOS scrolling
    }
  }

  // Function to enable body scrolling
  function enableBodyScroll() {
    // Remove class that prevents body scrolling
    document.body.classList.remove("menu-open");

    // Restore scroll position after unlocking
    if (window.menuScrollPosition !== undefined) {
      window.scrollTo(0, window.menuScrollPosition);
    }
  }

  // Function to set up accordion behavior
  function setupMobileMenuAccordion() {
    if (window.innerWidth <= 991) {
      // Only for mobile view
      // Apply white background and position below header
      const menuDrawer = document.getElementById("menu-drawer");
      if (menuDrawer) {
        menuDrawer.style.backgroundColor = "#ffffff";
        menuDrawer.style.width = "100%";
        menuDrawer.style.left = "0";
        menuDrawer.style.right = "0";
        menuDrawer.style.marginLeft = "0";
        menuDrawer.style.marginRight = "0";
        menuDrawer.style.paddingLeft = "0";
        menuDrawer.style.paddingRight = "0";
        menuDrawer.style.top = "125px"; // Position further below header
        menuDrawer.style.position = "fixed";
        menuDrawer.style.zIndex = "5"; // Lower z-index to not cover header
        menuDrawer.style.boxShadow = "0 5px 15px rgba(0,0,0,0.1)"; // Add subtle shadow

        // Enhance scrolling capabilities
        menuDrawer.style.overflowY = "auto";
        menuDrawer.style.overflowX = "hidden";
        menuDrawer.style.webkitOverflowScrolling = "touch"; // For better iOS scrolling

        // Force black text color on all elements for white background
        const allElements = menuDrawer.querySelectorAll("*");
        allElements.forEach((element) => {
          element.style.color = "#000000";
        });

        // Ensure inner navigation takes full width
        const navigation = menuDrawer.querySelector(".menu-drawer__navigation");
        if (navigation) {
          navigation.style.width = "100%";
          navigation.style.marginLeft = "0";
          navigation.style.marginRight = "0";
          navigation.style.paddingLeft = "0";
          navigation.style.paddingRight = "0";
        }

        // Ensure menu takes full width
        const menu = menuDrawer.querySelector(".menu-drawer__menu");
        if (menu) {
          menu.style.width = "100%";
          menu.style.margin = "0";
          menu.style.padding = "0";
        }

        // Force black text on all links and menu items
        const menuItems = menuDrawer.querySelectorAll(
          ".menu-drawer__menu-item"
        );
        menuItems.forEach((item) => {
          item.style.color = "#000000";
          const links = item.querySelectorAll("a");
          links.forEach((link) => {
            link.style.color = "#000000";
          });
        });

        // Remove the mega_menu_banner divs that cause unwanted gaps
        const megaMenuBanners = menuDrawer.querySelectorAll(
          ".mega_menu_banner, .container.mega_menu_banner, div.container"
        );
        megaMenuBanners.forEach((banner) => {
          // Remove the element completely from the DOM
          if (banner.parentNode) {
            banner.parentNode.removeChild(banner);
          }
        });

        // Add a mutation observer to remove any that might be added dynamically
        const menuObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.addedNodes && mutation.addedNodes.length > 0) {
              mutation.addedNodes.forEach((node) => {
                if (
                  node.classList &&
                  (node.classList.contains("mega_menu_banner") ||
                    node.classList.contains("container"))
                ) {
                  node.parentNode.removeChild(node);
                }
              });
            }
          });
        });

        // Start observing the menu for changes
        menuObserver.observe(menuDrawer, {
          childList: true,
          subtree: true,
        });
      }

      // Make sure the drawer container is properly set up
      const menuDrawerContainer = document.getElementById(
        "Details-menu-drawer-container"
      );

      // Ensure the menu doesn't cover the header
      if (menuDrawerContainer) {
        menuDrawerContainer.style.position = "relative";
        menuDrawerContainer.style.zIndex = "5";
      }

      // Set up accordion behavior for all menu details elements
      const menuDetails = document.querySelectorAll(".menu-drawer details");

      menuDetails.forEach((detail) => {
        const summary = detail.querySelector("summary");
        const submenu = detail.querySelector(".menu-drawer__submenu");

        if (summary && submenu) {
          // Style the detail element to keep items visible when open
          detail.style.display = "flex";
          detail.style.flexDirection = "column";

          // Make entire summary clickable
          summary.style.cursor = "pointer";

          // Add position: relative to summary to ensure it covers the whole area
          summary.style.position = "relative";

          // Ensure the entire summary area is clickable, not just the text
          summary.style.width = "100%";

          // Ensure summary is always visible
          summary.style.display = "flex";
          summary.style.visibility = "visible";
          summary.style.opacity = "1";

          // Make the entire summary clickable, not just the + icon
          const menuItem = summary.querySelector(".menu-drawer__menu-item");
          if (menuItem) {
            // Add cursor to menu item to indicate it's clickable
            menuItem.style.cursor = "pointer";
            menuItem.style.width = "100%";

            // Remove existing event listeners to prevent duplicates
            menuItem.removeEventListener("click", function (e) {
              e.preventDefault();
              summary.click(); // Trigger the summary click
            });

            // Add event listener to entire menu item
            menuItem.addEventListener("click", function (e) {
              e.preventDefault();
              summary.click(); // Trigger the summary click
            });
          }

          // Remove existing event listeners to prevent duplicates
          summary.removeEventListener("click", handleSummaryClick);

          // Add event listener
          summary.addEventListener("click", handleSummaryClick);

          // Make sure the submenu starts closed
          if (!detail.hasAttribute("open")) {
            submenu.classList.remove("is-open");
          } else {
            submenu.classList.add("is-open");
          }
        }
      });

      // Ensure menu tabs are visible and styled correctly
      const mobileTabs = document.querySelector(".mobilemenu-tab");
      if (mobileTabs) {
        if (mobileTabs.classList.contains("hidden")) {
          mobileTabs.classList.remove("hidden");
        }
        mobileTabs.style.display = "flex";
        mobileTabs.style.marginTop = "2px"; // Add 2px space below header
      }
    }
  }

  function handleSummaryClick(event) {
    // Prevent the default details open/close behavior
    event.preventDefault();

    const details = this.parentElement;
    const submenu = details.querySelector(".menu-drawer__submenu");

    // Toggle the open attribute and class
    if (details.hasAttribute("open")) {
      details.removeAttribute("open");
      submenu.classList.remove("is-open");
    } else {
      details.setAttribute("open", "");
      submenu.classList.add("is-open");
      
      // Make sure all sibling menu items remain visible when expanding
      // This fixes the issue with first non-expandable item disappearing in brands tab
      const parentList = details.parentElement;
      if (parentList) {
        const siblingItems = parentList.querySelectorAll(':scope > li');
        siblingItems.forEach(item => {
          item.style.display = "block";
          item.style.visibility = "visible";
          item.style.height = "auto";
          
          // Fix for any menu items that might be direct children (non-expandable items)
          const menuItems = item.querySelectorAll('.menu-drawer__menu-item');
          menuItems.forEach(menuItem => {
            menuItem.style.display = "block";
            menuItem.style.visibility = "visible";
          });
        });
      }
    }

    // Always keep the summary visible
    this.style.display = "flex";
    this.style.visibility = "visible";
    this.style.position = "relative";
    this.style.opacity = "1";
  }

  // Initial setup
  setupMobileMenuAccordion();

  // Handle resize events
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setupMobileMenuAccordion, 250);
  });

  // Re-run setup after the menu drawer might have been initialized by other scripts
  setTimeout(setupMobileMenuAccordion, 1000);

  // Make sure it applies when menu is opened
  document.addEventListener("click", (e) => {
    if (e.target.closest(".header__icon--menu")) {
      // Add a small delay to ensure the details element has toggled first
      setTimeout(() => {
        const menuDrawerContainer = document.getElementById(
          "Details-menu-drawer-container"
        );
        if (menuDrawerContainer && menuDrawerContainer.hasAttribute("open")) {
          // Menu is open, apply styles
          setupMobileMenuAccordion();
          // Disable scrolling when menu is open
          isMenuOpen = true;
          disableBodyScroll();
          
          // Fix for BRANDS tab items disappearing
          fixBrandsTabVisibility();
        } else {
          // Menu is closed
          isMenuOpen = false;
          enableBodyScroll();
        }
      }, 10);
    } else if (e.target.closest(".menu-drawer__menu-item")) {
      setTimeout(() => {
        setupMobileMenuAccordion();
        // Fix for BRANDS tab items disappearing when menu items are clicked
        fixBrandsTabVisibility();
      }, 100);
    } else if (e.target.closest(".mobilemenu-tab li")) {
      // Tab switching - fix visibility when switching tabs
      setTimeout(fixBrandsTabVisibility, 100);
    }
  });
  
  // Function to fix visibility issues in Brands tab
  function fixBrandsTabVisibility() {
    // Get all menu items and make sure they're visible
    const allMenuItems = document.querySelectorAll('.menu-drawer__menu-item');
    allMenuItems.forEach(item => {
      item.style.display = "block";
      item.style.visibility = "visible";
    });
    
    // Get all list items and make sure they're visible
    const allListItems = document.querySelectorAll('.menu-drawer__menu > li');
    allListItems.forEach(item => {
      item.style.display = "block";
      item.style.visibility = "visible";
      item.style.height = "auto";
    });
  }

  // Monitor for menu closing in other ways
  const menuDrawerContainer = document.getElementById(
    "Details-menu-drawer-container"
  );
  if (menuDrawerContainer) {
    const menuObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "open"
        ) {
          if (!menuDrawerContainer.hasAttribute("open") && isMenuOpen) {
            // Menu was closed
            isMenuOpen = false;
            enableBodyScroll();
          }
        }
      });
    });

    // Start observing the menu container for open/close status
    menuObserver.observe(menuDrawerContainer, { attributes: true });
  }
});
